import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { StudentSkillStates } from '../../models/StudentSkillState';

export interface PreviousAndNextSSS {
  previousState: StudentSkillStates | null;
  nextState: StudentSkillStates | null;
}

const sSSinitialState = { previousState: null, nextState: null };

export interface StudentSkillsState {
  value: PreviousAndNextSSS;
}

const initialState: StudentSkillsState = { value: sSSinitialState };

export const studentSkillAfterTakeAssessmentSlice = createSlice({
  name: 'studentSkillAfterTakeAssessment',
  initialState,
  reducers: {
    setStudentSkillAfterTakeAssessment: (state: StudentSkillsState, action: PayloadAction<PreviousAndNextSSS>) => {
      state.value = action.payload;
    },
  },
});

export const selectedStudentSkillStateAfterTakeAssessment = (state: RootState) =>
  state?.studentSkillAfterTakeAssessment?.value;

export const { setStudentSkillAfterTakeAssessment } = studentSkillAfterTakeAssessmentSlice.actions;

export default studentSkillAfterTakeAssessmentSlice.reducer;
